import styled from 'styled-components'

export const LoaderContainer = styled('div')`
  width: 100%;
  background: white;
  margin: 0 0 15px;
  border-radius: 8px;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.12);
`
